import React from 'react';

export default function MobileMenu(props) {
  return (
    <div>MobileMenu</div>
  )
}
